import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import _ from 'lodash';
import { sum } from 'lodash';
import { IconAlertTriangle } from '@tabler/icons';
import { Grid } from '@mantine/core';
import { Switch } from '@mantine/core';
import { Button } from '@mantine/core';
import { Space } from '@mantine/core';
import { Collapse, Center } from '@mantine/core';
import { Paper } from '@mantine/core';
import { Text } from '@mantine/core';
import { RangeSlider } from '@mantine/core';
import { NumberInput } from '@mantine/core';

import {Title } from '@mantine/core';

import { GetDashboardStatistic } from './GetDashboardStatistic';
import DashboardSearch from './DashboardSearch';
import { fetchDashboard, getAutocompleteList} from '../../actions/dashboard';
import { Checkbox } from '../input/Checkbox';
import ContainerTranslation from "../partials/ContainerTranslation";


const marks = [
  { value: -96, label: "juqu'a 8 ans " },
  { value: -48, label: "jusqu'a 4 ans" },
  { value: 0, label: "aujourd'hui" },
];

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        const { fetchDashboard } = this.props;
        const { getAutocompleteList } = this.props;
        this.state = {
          opened: true,
          filtersByOr: [],
          checkBox:[false,false,false,false,false,false], //[isactif,70%+,man,women,typologyrécente,bureaufrance]
          searchTerm: '',
          consultantsToExport: [],
          user: JSON.parse(localStorage.getItem("user")),
          consultantInfos: {},
          consultants : [],
          clientsExpertiseMin:[0,0,0,0,0,0,0,0,0,0],
          clientsExpertiseMax:[15,15,15,15,15,15,15,15,15,15],
          environnementExpertiseMax:[15,15,15,15,15,15,15,15,15,15],
          environnementExpertiseMin:[0,0,0,0,0,0,0,0,0,0],
          interventionExpertiseMin:[0,0,0,0,0,0,0,0,0,0],
          interventionExpertiseMax:[15,15,15,15,15,15,15,15,15,15],
          expertiseExpertiseMax:[15,15,15,15,15,15,15,15,15,15],
          expertiseExpertiseMin:[0,0,0,0,0,0,0,0,0,0],
          cityExpertise:[1,1,1,1,1,1,1,1,1,1],
          reload:0,
          domainExpertiseMin:[1,1],
          domainExpertiseMax:[15,15],
          typologyYear1:4,
          typologyYear2:0,
          domainChecked:true,
          isLoading : true,
          selectedItems : this.props.filter ? this.props.filter :  {
            'clients':[],
            'country':[],
            'environnement':{
                'environnement-domain':[],
                'environnement-context':[]
              },
            'typologies':[],
            'intervention-level':{
                'intervention-type':[],
                'intervention-mission':[],
                'intervention-application':[]
              },
            'expertise':{
                'domain-competence':[],
                'domain-speciality':[],
                'domain-specificity':[],
                'domain-other':[]
              },
            'engineering':{
                'engineering-skill':[],
                'engineering-specialization' : [],
            },
            'seniority':[],
          }
        }
        getAutocompleteList();
        fetchDashboard();
    }

    componentDidMount(){
    }

    handleSwitchDomainChange = (event) => {
      this.setState({ domainChecked: event.currentTarget.checked });
    };

    componentDidUpdate(prevProps, prevState){
      let _this = this
      if(this.state.isLoading && _this.props.data){
        let dataWithInitalFilter = []
        _.forEach(_this.props.data,function(consultant){
          dataWithInitalFilter.push(consultant)
        })
        this.setState({
            consultants: dataWithInitalFilter,
            isLoading : false
        })
      }
      if(prevState.validationFilter !== _this.state.validationFilter || prevState.filtersByOr.length !== _this.state.filtersByOr.length || prevState.checkBox !== _this.state.checkBox
        || prevState.reload !== _this.state.reload  ){
        this.filterDashboard(this.state.selectedItems)
      }
    }

    toggle = () => {
      this.setState((prevState) => ({
        opened: !prevState.opened,
      }));
    };



    handleRangeChange = (newValues, index, property) => {
      const [minValue, maxValue] = newValues;
      this.setState((prevState) => ({
        [`${property}Min`]: prevState[`${property}Min`].map((item, i) =>
          i === index ? minValue : item
        ),
        [`${property}Max`]: prevState[`${property}Max`].map((item, i) =>
          i === index ? maxValue : item
        ),
      }));
    };

    handleRangeChange_Domain = (newValues, index) => {
      this.handleRangeChange(newValues, index, 'domainExpertise');
    }

    handleRangeChange_Client = (newValues, index) => {
      this.handleRangeChange(newValues, index, 'clientsExpertise');
    }; 

    handleRangeChange_Expertise = (newValues, index) => {
      this.handleRangeChange(newValues, index, 'expertiseExpertise');
    };

    handleRangeChange_Intervention = (newValues, index) => {
      this.handleRangeChange(newValues, index, 'interventionExpertise');
    };

    handleRangeChange_Environnement = (newValues, index) => {
      this.handleRangeChange(newValues, index, 'environnementExpertise');
    };


    filterDataToChart(consultants){
      let dataToExport = []
      _.forEach(consultants, function(consultant) {
        if(consultant.projects !== 0){
          dataToExport.push(consultant)
        } else {
          let newContent = consultant
          consultant.projects = []
          dataToExport.push(newContent)
        }
      })
      return(dataToExport)
    }


    foundCityListFrance(consultants) {
      const cityCounts = {
        'Nantes': 0,
        'Aix-en-Provence': 0,
        'Lyon': 0,
        'Paris': 0,
        'Marseille': 0,
        'Toulouse': 0,
        'Lille': 0,
      };
      _.forEach(consultants, function(consultant) {
        const city = consultant.user.sageContent.filiale.city;
        if (city in cityCounts) {
          cityCounts[city] += 1;
        }
      });
      return Object.values(cityCounts);
    }


    filterDashboard(items){
        let _this = this
        let  filtersByOr = this.state.filtersByOr;
        let  filtredList = [];

        //FILTER BY OR
        _.forEach(items, function(parentItem, parentItemKey){
          if(Array.isArray(parentItem)){
            if(parentItem.length && parentItemKey === "clients"){
              _this.props.data.forEach((consultant) => {
                let mapConsultant = _.map(consultant.projects,function(project){
                  return project.content.client.level_1 ? project.content.client.level_1.value : ""
                })
                mapConsultant = _.filter(mapConsultant,function(x){return x !== ""})
                if (filtersByOr.find(i => i === parentItemKey.toString()) && _.intersection(mapConsultant, parentItem).length > 0 ) {
                  return filtredList.push(consultant)
                }
              })
            }
            else if (parentItem.length && parentItemKey !== "clients" && parentItemKey !== "country"){
              _this.props.data.forEach((consultant) => {
                let  mapConsultant = consultant.content[parentItemKey]
                if (filtersByOr.find(i => i === parentItemKey.toString()) && _.intersection(mapConsultant, parentItem).length > 0 ) {
                  return filtredList.push(consultant)
                }
              })
            }
          }else if (!parentItem.length || parentItem.length === 0){
            _.forEach(parentItem, function(item, itemKey){
              if(item.length){
                _this.props.data.forEach((consultant) => {
                  let  mapConsultant = consultant.content[parentItemKey]
                  if(mapConsultant && Array.isArray(mapConsultant)){
                    mapConsultant = _.map(mapConsultant, itemKey)
                    if (filtersByOr.find(i => i === parentItemKey.toString()) && _.intersection(mapConsultant, item).length > 0 ) {
                      return filtredList.push(consultant)
                    }
                  } else {
                    if(mapConsultant && Array.isArray(mapConsultant[itemKey])){
                      let  arrayToTest = mapConsultant[itemKey]
                      if(typeof(mapConsultant[itemKey][0]) === 'object'){
                        arrayToTest = _.map(arrayToTest, 'name')
                      }
                      if (filtersByOr.find(i => i === parentItemKey.toString()) && _.intersection(arrayToTest, item).length > 0 ) {
                        return filtredList.push(consultant)
                      }
                    } else {
                      if (filtersByOr.find(i => i === parentItemKey.toString()) && consultant.content[parentItemKey.toString()] && consultant.content[parentItemKey.toString()][itemKey.toString()]) {
                        if(itemKey==="environnement-domain"){
                          return filtredList.push(consultant)
                        }
                      }
                    }
                  }
                })
              }
            })
          }
        });
    
        
        //FILTER BY AND
        let results  = filtredList.length > 0 ? filtredList : _this.props.data ;
    
        let filters = {};
        Object.keys(items).forEach(item => {
          if(!filtersByOr.find(parent => parent === item )) {
            filters[item] = items[item];
          }
        })
    
        _.forEach(filters, function(parentItem, parentItemKey){
          if(Array.isArray(parentItem)){
            if(parentItem.length && parentItemKey === "clients"){
              results = _.filter(results, function(consultant){
                let mapConsultant = _.map(consultant.projects,function(project){
                  return project.content.client.level_1 ? project.content.client.level_1.value : ""
                })
                mapConsultant = _.filter(mapConsultant,function(x){return x !== ""}) 
                return _.intersection(mapConsultant, parentItem).length > 0 ;
              })
            }
            //filter here, execpt all key words that are not in consultant.content
            else if (parentItem.length && parentItemKey !== "clients" && parentItemKey !== "country" && parentItemKey !== "seniority"){
              results = _.filter(results, function(consultant){
                let mapConsultant = consultant.content[parentItemKey]
                  return _.intersection(mapConsultant, parentItem).length > 0 ;
              })
            }
            else if (parentItem.length && parentItemKey === "country"){
              results = _.filter(results, function(consultant){
                let mapConsultant = [consultant.user.sageContent.filiale[parentItemKey]]
                  return _.intersection(mapConsultant, parentItem).length > 0 ;
              })
            }
            else if (parentItem.length && parentItemKey === "seniority"){
              results = _.filter(results, function(consultant){
                let mapConsultant = [consultant[parentItemKey]]
                  return _.intersection(mapConsultant, parentItem).length > 0 ;
              })
            }
          }else{
            _.forEach(parentItem, function(item, itemKey){
              if(item.length){
                results = _.filter(results, function(consultant){
                  let mapConsultant = consultant.content[parentItemKey]
                  if(mapConsultant && Array.isArray(mapConsultant)){
                    mapConsultant = _.map(mapConsultant, itemKey)
                    return _.intersection(mapConsultant, item).length > 0
                  } 
                  if (itemKey === "environnement-domain"){
                    return(consultant)
                  }
                  if (itemKey === "environnement-context") {
                    const { "environnement-context": { Energy, Railway } } = consultant.content[parentItemKey];
                    const energyMapConsultant = Energy[parentItem["environnement-context"][0]];
                    const railwayMapConsultant = Railway[parentItem["environnement-context"][0]];
                    return energyMapConsultant > 0 || railwayMapConsultant > 0;
                  }
                  else {
                    if(mapConsultant && Array.isArray(mapConsultant[itemKey])){
                      let arrayToTest = mapConsultant[itemKey]
                      if(typeof(mapConsultant[itemKey][0]) === 'object'){
                        arrayToTest = _.map(arrayToTest, 'name')
                      }
                        return _.intersection(arrayToTest, item).length > 0
                    } else {
                        if (consultant[parentItemKey.toString()] && consultant[parentItemKey.toString()][itemKey.toString()]) {
                          return item.indexOf(consultant.consultant.content[parentItemKey.toString()][itemKey.toString()]) !== -1 ;
                        }
                    }
                  }
                })
              }
            })
          }
        })



    
        this.setState({
          selectedItems:items,
          consultants: _.uniqBy(results, '_id'),
        })

        // -----------------------------------------------------
        //legacy filter ends here, secondary filter start here
        // -----------------------------------------------------
        let newResults = _.uniqBy(results, '_id')

        
        //if filter is active (no end date)
        if (this.state.checkBox[0]===true) {
          let newData = []
          _.forEach(newResults,function(consultant){
            if (consultant.user.sageContent.endDate === undefined || consultant.user.sageContent.endDate === null) {
              newData.push(consultant)
              newResults = newData
            }
          })
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }

        // if filter valided at 70% or more
        if (this.state.checkBox[1]===true){
          let newData = []
          _.forEach(newResults,function(consultant){
            if (consultant.content.progression ) {
              if (consultant.content.progression>69 ) {
                newData.push(consultant)
                newResults = newData
              }
            }
          })
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }


        // if filter gender is activated
        if (this.state.checkBox[2]===true || this.state.checkBox[3]===true){
          let male = ""
          let female = ""
          if(this.state.checkBox[2]===true){
            male = "Male"
          }
          if(this.state.checkBox[3]===true){
            female = "Female"
          }
          let newData = []
          _.forEach(newResults,function(consultant){
            if (consultant.user.sageContent.profile.gender === male || consultant.user.sageContent.profile.gender === female ) {
              newData.push(consultant)
            }
          })
          newResults = newData
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }


        //if filter is typology 
        if (this.state.checkBox[4]===true) {
          let newData = []
          let today = new Date();
          today = today.getFullYear() + (today.getMonth() + 1)/12 //+ today.getDate()/366
          _.forEach(newResults,function(consultant){
            _.forEach(consultant.projects,function(project){
              if (project.content.information){
                let start = 0
                let end = 0
                if(project.content.information["start-date"].length>0){
                  start = parseInt(project.content.information["start-date"].slice(-4)) + 
                  (parseInt(project.content.information["start-date"][3]) + parseInt(project.content.information["start-date"][4]))/12
                }
                if(project.content.information["end-date"]){
                  if(project.content.information["end-date"].length>0){
                    end = parseInt(project.content.information["end-date"].slice(-4)) + 
                    (parseInt(project.content.information["end-date"][3]) + parseInt(project.content.information["end-date"][4]))/12
                  }
                } else {
                  end = today
                }
                if( start >= (today-_this.state.typologyYear1) && end <= (today-_this.state.typologyYear2) && end !== 0 && start !== 0){
                  newData.push(consultant) 
                }
              }
            })
          })
          newData = [...new Set(newData)];
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }


        let listOfexpertise = this.state.clientsExpertiseMin
        let nbClient = this.state.selectedItems.clients.length
        if (this.state.selectedItems.clients.length>0 && sum(listOfexpertise)>0){
          let newData = []
          _.forEach(newResults,function(consultant){
            let totalExpertise = []
            totalExpertise.length = nbClient;
            totalExpertise.fill(0);
            let projectList = consultant.projects
            _.forEach(projectList,function(projet){
              for(let i = 0; i <_this.state.selectedItems.clients.length; i++){
                if(projet.content.client.level_1.value === _this.state.selectedItems.clients[i]){
                  if(projet.content.information["end-date"]){
                    if(projet.content.information["end-date"].length>0){
                      totalExpertise[i] = totalExpertise[i] + parseInt(projet.content.information["end-date"].slice(-4)) - parseInt(projet.content.information["start-date"].slice(-4))
                      + parseFloat(projet.content.information["end-date"][3] + projet.content.information["end-date"][4])/12 -
                      parseFloat(projet.content.information["start-date"][3] + projet.content.information["start-date"][4])/12 + 1/12
                    }
                  } else { // end is today (project not finished)
                    totalExpertise[i] = totalExpertise[i] + new Date().getFullYear() - parseInt(projet.content.information["start-date"].slice(-4))
                    + new Date().getMonth()/12 + 1/12 - parseFloat(projet.content.information["start-date"][3] + projet.content.information["start-date"][4])/12
                  }
                }  
              }       
            })
            for(let i = 0; i < nbClient; i++){
              if (totalExpertise[i] >= listOfexpertise[i]) {
                newData.push(consultant)
              }
            }
          })
          if(listOfexpertise.length>1){
            newData = [...new Set(newData)];
          }
          newResults = newData
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }


        //if filter by energy/ferro range year
        const domainFilterSize = this.state.selectedItems.environnement["environnement-domain"].length
        if( domainFilterSize > 0 ){
          let newData = []
          const environnementDomain = this.state.selectedItems.environnement["environnement-domain"]
          const domainExpertiseMinLocal = this.state.domainExpertiseMin
          const domainExpertiseMaxLocal = this.state.domainExpertiseMax
          _.forEach(newResults,function(consultant){ 
            const rail = consultant.content.environnement["environnement-domain"].Railway
            const ener = consultant.content.environnement["environnement-domain"].Energy
            if(_this.state.domainChecked ){
              if( environnementDomain.includes('Railway') && (rail >= (1)*domainExpertiseMinLocal[0] && rail <= (1)*domainExpertiseMaxLocal[0]) ){
                newData.push(consultant)
              }
              if( environnementDomain.includes('Energy') &&  (ener >= (1)*domainExpertiseMinLocal[1] && ener <= (1)*domainExpertiseMaxLocal[1]) ){
                newData.push(consultant)
              }
            } else {
              if(
                ( environnementDomain.includes('Railway') && (rail >= (1)*domainExpertiseMinLocal[0] && rail <= (1)*domainExpertiseMaxLocal[0]) )
                &&
                ( environnementDomain.includes('Energy') &&  (ener >= (1)*domainExpertiseMinLocal[1] && ener <= (1)*domainExpertiseMaxLocal[1]) )
              ){
                newData.push(consultant)
              }
            }
          })
          newData = [...new Set(newData)];
          newResults = newData
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }

        //if filter by intervention
        let interventionAll = this.state.selectedItems["intervention-level"]["intervention-application"].concat(
          this.state.selectedItems["intervention-level"]["intervention-mission"],
          this.state.selectedItems["intervention-level"]["intervention-type"]
        )
        if (interventionAll.length>0){
          let newData = []
          let expertiseLocal = this.state.interventionExpertiseMin
          _.forEach(newResults,function(consultant){
            _.forEach(consultant.content["intervention-level"],function(intervention){ 
              for(let i = 0; i<interventionAll.length; i++){
                if(intervention["intervention-application"]===interventionAll[i]
                || intervention["intervention-mission"] === interventionAll[i]
                || intervention["intervention-type"] === interventionAll[i]
                || intervention.label === interventionAll[i]
                || intervention.name === interventionAll[i] ){
                  if( intervention["intervention-experience"]>= expertiseLocal[i] )
                  newData.push(consultant)
                }
              }
            })
          })
          if(listOfexpertise.length>1){
            newData = [...new Set(newData)];
          }
          newResults = newData
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }


        //filter by domain context
        if (this.state.selectedItems.environnement["environnement-context"].length>0){
          let newData = []
          const expertiseLocalMax = this.state.environnementExpertiseMax
          const expertiseLocalMin = this.state.environnementExpertiseMin
          const domainContext = this.state.selectedItems.environnement["environnement-context"]
          _.forEach(newResults,function(consultant){
            const { Railway: rail, Energy: ener } = consultant.content.environnement["environnement-context"];
            const combinedData = { ...rail, ...ener };
            //...
            _.forEach( domainContext ,function(value,index){
              if(index<=10){
                if(+combinedData[value]>=expertiseLocalMin[index] && +combinedData[value]<=expertiseLocalMax[index]){
                  newData.push(consultant)
                }
              }
            })
          })
          newData = [...new Set(newData)];
          newResults = newData
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }


        //if filter by expertise domain
        let expertiseAll = this.state.selectedItems.expertise["domain-competence"].concat(
          this.state.selectedItems.expertise["domain-speciality"],
          this.state.selectedItems.expertise["domain-specificity"])
        let newData = []
        if (expertiseAll.length>0){
          let expertiseLocalMax = this.state.expertiseExpertiseMax
          let expertiseLocalMin = this.state.expertiseExpertiseMin
          _.forEach(newResults,function(consultant){
            _.forEach(consultant.content.expertise,function(expertise){ 
              for(let i = 0; i<expertiseAll.length; i++){
                if(expertise["domain-competence"]=== expertiseAll[i]
                || expertise["domain-speciality"] === expertiseAll[i]
                || expertise["domain-specificity"] === expertiseAll[i] ){
                  if( expertise["domain-experience"] >= expertiseLocalMin[i] && expertise["domain-experience"] <= expertiseLocalMax[i] ){
                    newData.push(consultant)
                  }
                }
              }
            })
          })
          //if(listOfexpertise.length>1){
            newData = [...new Set(newData)];
          //}
          newResults = newData
          this.setState({
            selectedItems:items,
            consultants: newData,
          })
        }


        //if filter by bureau and expertise inside france
        if (this.state.selectedItems.country.includes("France") && this.state.checkBox){
          
          
        }





        newResults = [] //empty result at the end when is no more needed
        // -------------------------------
        //end of new filter

      };


    setFilterByOr(selectParent) {
        let list = _.cloneDeep(this.state.filtersByOr);
        if (this.state.filtersByOr.find(item => item === selectParent )) {
          list = list.filter(item => item !== selectParent);
        } else {
          list.push(selectParent);
        }
        this.setState({ filtersByOr: list });
      }

      selectItem(data) {
        let items = this.state.selectedItems;
        if(data && data.name){
          items[data.parent][data.name] = data.value
        } else if (data && data.parent) {

          items[data.parent] = data.value
        }
        this.filterDashboard(items)
      }



      filterCheckBox(index){
        if(this.state.checkBox[index]===false){
          let result = [this.state.checkBox[0],this.state.checkBox[1],this.state.checkBox[2],this.state.checkBox[3],this.state.checkBox[4],this.state.checkBox[5]]
          result[index] = true
          return(result)
        } else {
          let result = [this.state.checkBox[0],this.state.checkBox[1],this.state.checkBox[2],this.state.checkBox[3],this.state.checkBox[4],this.state.checkBox[5]]
          result[index] = false
          return(result)
        }
      }

      gridSize(condition){
        if(condition.length>0){
          return(4)
        } else {
          return(0)
        }
      }

      indexMoveViewTo(whereToGo){
        document.getElementById(whereToGo).scrollIntoView({behavior: 'smooth'})
      }


      getDomainContextIndex(stringDomain){
        if(stringDomain === "Railway") {
          return(0)
        } else {
          return(1)
        }
      }
      





    render() {
    
      const { opened } = this.state;

      if (!this.props.data || !this.props.list ) {
        return <> Loading ... </>
      }

      const { expertiseExpertiseMin, expertiseExpertiseMax, domainExpertiseMax, domainExpertiseMin,
        domainChecked, clientsExpertiseMax, clientsExpertiseMin, interventionExpertiseMin, interventionExpertiseMax,
        environnementExpertiseMin, environnementExpertiseMax } = this.state;

      const switchStyles = {
        color: this.state.domainChecked ? 'teal' : 'orange',
      };

      return (

        <div>

          <Grid >
            <Grid.Col span={5}>
              <div className="formulaires">
                <div className="formulaire-section" >
                  <Title order={3} c='#52BCC2'>
                    <ContainerTranslation id={'Filters'} />
                  </Title>
                  <div className="formulaire-header">
                    <p className="info">
                      <ContainerTranslation id={'Page.Consultant.Filters-info'} />
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Col>

            <Grid.Col span={12}>

              <Paper shadow="xl" radius="lg" p="xl">
              <Grid>
                <Grid.Col span={4}>
                  <Space h="xs" />
                  <Checkbox
                    checked={this.state.checkBox[0]}
                    label={this.props.translate("content.extract.dashboard.filter.isActive")}
                    onClick={ () => this.setState({ checkBox : this.filterCheckBox(0) }) }
                  />
                  <Space h="xs" />
                  <Checkbox
                    checked={this.state.checkBox[1]}
                    label={<Text size="sm" > {this.props.translate("content.extract.dashboard.filter.isProfileFilled")} </Text>}
                    onClick={ () => this.setState({ checkBox : this.filterCheckBox(1) }) }
                  />
                </Grid.Col>

                <Grid.Col span={4}>
                  <Checkbox
                    checked={this.state.checkBox[4]}
                    label={this.props.translate("content.extract.dashboard.filter.isNewProject")}
                    onClick={ () => this.setState({ checkBox : this.filterCheckBox(4) }) }
                  />
                  {/*check box bureau france n'apparait que si la france est selectionner*/}
                  {this.state.selectedItems.country.includes("France") ? 
                  <>
                    <Space h="xs" />
                    <Checkbox
                      checked={this.state.checkBox[5]}
                      label="Bureau france"
                      onClick={ () => this.setState({ checkBox : this.filterCheckBox(5) }) }
                    />
                  </> 
                  :<></>}
                </Grid.Col>

                <Grid.Col span={4}>
                  <Checkbox
                    checked={this.state.checkBox[2]}
                    label={this.props.translate("content.extract.dashboard.filter.isAMan")}
                    onClick={ () => this.setState({ checkBox : this.filterCheckBox(2) }) }
                  />
                  <Space h="xs" />
                  <Checkbox
                    checked={this.state.checkBox[3]}
                    label={this.props.translate("content.extract.dashboard.filter.isAWoman")}
                    onClick={ () => this.setState({ checkBox : this.filterCheckBox(3) }) }
                  />
                </Grid.Col>

              </Grid>
              </Paper>
            </Grid.Col>


            <Grid.Col span={12}>
              <Paper>
                <DashboardSearch
                  searchTerm={this.state.searchTerm}
                  searchUpdated={this.searchUpdated}
                  consultants={this.state.consultants}
                  initConsultants={this.props.data}
                  filtersByOr={this.state.filtersByOr}
                  setFilterByOr={this.setFilterByOr.bind(this)}
                  selectedItems={this.state.selectedItems}
                  selectItem={this.selectItem.bind(this)}
                />
              </Paper>
            </Grid.Col>

            <Grid.Col span={12}>
              <Collapse in={opened}>
                <Grid justify="center" >                    
                    {this.state.selectedItems.clients.length>0 ? 
                    <>
                      <Grid.Col span={4}>
                      <Paper shadow="xl" radius="lg" p="xl">
                      {this.state.selectedItems.clients.map((client, index) => (
                      <>
                        {this.props.translate("content.extract.dashboard.UI.Expertise" )}
                        <Text size="sm" c="dimmed"> {this.props.translate("content.extract.dashboard.UI.au moins" )} {clientsExpertiseMin[index]} {this.props.translate("content.extract.dashboard.UI.ans, au maximum" )} {clientsExpertiseMax[index]} {this.props.translate("content.extract.dashboard.UI.ans" )} </Text>
                        {client}
                        <Space h="xs" />
                        <RangeSlider
                          min={0}
                          max={15}
                          step={1}
                          minRange={1}
                          style={{ position: 'relative', zIndex: 0 }}
                          value={[clientsExpertiseMin[index], clientsExpertiseMax[index]]}
                          onChange={(newValues) => this.handleRangeChange_Client(newValues, index)}
                        />
                        <Space h="xl" />
                      </>
                    ))}
                    </Paper></Grid.Col></> : <></>}

                    {/* environnement domain*/}
                    {this.state.selectedItems.environnement["environnement-domain"].length>0 ? 
                      <>
                        <Grid.Col span={4}>
                        <Paper shadow="xl" radius="lg" p="xl">
                        {this.state.selectedItems.environnement["environnement-domain"].map((energy, index) => (
                        <>
                          {this.props.translate("content.extract.dashboard.UI.Expertise" )}
                          <Text size="sm" c="dimmed"> {this.props.translate("content.extract.dashboard.UI.au moins" )} {domainExpertiseMin[this.getDomainContextIndex(energy)]} {this.props.translate("content.extract.dashboard.UI.ans, au maximum" )} { domainExpertiseMax[this.getDomainContextIndex(energy)]} {this.props.translate("content.extract.dashboard.UI.ans" )} </Text>
                          {this.props.translate("secteur." + energy )}
                          <Space h="xs" />
                          <RangeSlider
                            min={0}
                            max={15}
                            step={1}
                            minRange={1}
                            style={{ position: 'relative', zIndex: 0 }}
                            value={[domainExpertiseMin[this.getDomainContextIndex(energy)], domainExpertiseMax[this.getDomainContextIndex(energy)]]}
                            onChange={(newValues) => this.handleRangeChange_Domain(newValues, this.getDomainContextIndex(energy))}
                          />
                          <Space h="xl" />
                          { (index === 0 && this.state.selectedItems.environnement["environnement-domain"].length === 2) || (this.state.domainChecked === false && index === 0) ? 
                            <>
                              <Center>
                                <Switch
                                  checked={domainChecked}
                                  style={switchStyles}
                                  onChange={this.handleSwitchDomainChange}
                                  size="lg"
                                  onLabel="OU" offLabel="ET"
                                />
                                {(this.state.domainChecked === false && index === 0 && this.state.selectedItems.environnement["environnement-domain"].length === 1) ? 
                                <>
                                <Space h="xs" />
                                <Text style={{color: 'red'}} size="xs" c="dimmed">
                                  <IconAlertTriangle style={{ width: '20%', height: '20%' }} />
                                  {this.props.translate("content.extract.dashboard.UI.warningAbout&&" )}
                                </Text>
                                </>
                                :null }
                              </Center>
                              <Space h="xl" />
                            </>
                          :null}
                        </>
                      ))}
                      </Paper></Grid.Col></> : <></>}

                      {this.state.checkBox[4] ? <>
                        <Grid.Col span={8}>
                        <Paper shadow="xl" radius="lg" p="xl">
                          <Text fw={500}> Projet récent :  </Text>
                          <Space h="md" />
                          <Grid>
                            <Grid.Col span={2}>
                              <NumberInput placeholder="années"
                                value={this.state.typologyYear1}
                                onChange={(typologyYear1) => this.setState({ typologyYear1 })}
                              /> 
                            </Grid.Col>
                            {/*slider */}
                            <Grid.Col span={9}>
                              <RangeSlider       
                              min={-120}
                              max={0}
                              step={1}
                              value={[-this.state.typologyYear1*12,-this.state.typologyYear2*12]}
                              onChange={(values) => {
                                const [typologyYear1, typologyYear2] = values.map(
                                  (value) => - value / 12
                                );
                                this.setState({ typologyYear1, typologyYear2 });
                              }}
                              marks={marks} />
                            </Grid.Col>
                          </Grid>
                          <Space h="lg" />
                        </Paper>
                      </Grid.Col>
                    </>:<></>}


                              {/* intervention */}
                    {(this.state.selectedItems["intervention-level"]["intervention-application"].length>0
                    || this.state.selectedItems["intervention-level"]["intervention-mission"].length>0
                    || this.state.selectedItems["intervention-level"]["intervention-type"].length>0) ? 
                    <>
                      <Grid.Col span={4}>
                      <Paper shadow="xl" radius="lg" p="xl">
                      {this.state.selectedItems["intervention-level"]["intervention-application"].concat(
                        this.state.selectedItems["intervention-level"]["intervention-mission"],
                        this.state.selectedItems["intervention-level"]["intervention-type"]
                      ).map((intervention, index) => (
                      <>
                        {this.props.translate("content.extract.dashboard.UI.Expertise" )}
                        <Text size="sm" c="dimmed"> {this.props.translate("content.extract.dashboard.UI.au moins" )} {interventionExpertiseMin[index]} {this.props.translate("content.extract.dashboard.UI.ans, au maximum" )} {interventionExpertiseMax[index]} {this.props.translate("content.extract.dashboard.UI.ans" )} </Text>
                        {this.props.translate("intervention-type." + intervention )}
                        <Space h="xs" />
                        <RangeSlider
                          min={0}
                          max={15}
                          step={1}
                          minRange={1}
                          style={{ position: 'relative', zIndex: 0 }}
                          value={[interventionExpertiseMin[index], interventionExpertiseMax[index]]}
                          onChange={(newValues) => this.handleRangeChange_Intervention(newValues, index)}
                        />
                        <Space h="xl" />
                      </>
                    ))}
                    </Paper></Grid.Col></> : <></>}



                          {/* expertise domain */}
                    {(this.state.selectedItems.expertise["domain-competence"].length>0
                    || this.state.selectedItems.expertise["domain-speciality"].length>0
                    || this.state.selectedItems.expertise["domain-specificity"].length>0) ? 
                    <>
                      <Grid.Col span={4}>
                      <Paper shadow="xl" radius="lg" p="xl">
                      {this.state.selectedItems.expertise["domain-competence"].concat(
                        this.state.selectedItems.expertise["domain-speciality"],
                        this.state.selectedItems.expertise["domain-specificity"]
                      ).map((domain, index) => (
                      <>
                        {this.props.translate("content.extract.dashboard.UI.Expertise" )}
                        <Text size="sm" c="dimmed"> {this.props.translate("content.extract.dashboard.UI.au moins" )} {expertiseExpertiseMin[index]} {this.props.translate("content.extract.dashboard.UI.ans, au maximum" )} {expertiseExpertiseMax[index]} {this.props.translate("content.extract.dashboard.UI.ans" )} </Text>
                        {this.props.translate("domain-competence." + domain )}
                        <Space h="xs" />
                        <RangeSlider
                          min={0}
                          max={15}
                          step={1}
                          minRange={1}
                          style={{ position: 'relative', zIndex: 0 }}
                          value={[expertiseExpertiseMin[index], expertiseExpertiseMax[index]]}
                          onChange={(newValues) => this.handleRangeChange_Expertise(newValues, index)}
                        />
                        <Space h="xl" />
                      </>
                    ))}
                    </Paper></Grid.Col></> : <></>}


                    {/* environnement context */}
                    {(this.state.selectedItems.environnement["environnement-context"].length>0) ? 
                    <>
                      <Grid.Col span={4}>
                      <Paper shadow="xl" radius="lg" p="xl">
                      {this.state.selectedItems.environnement["environnement-context"].map((domain, index) => (
                      <>
                        {this.props.translate("content.extract.dashboard.UI.Expertise" )}
                        <Text size="sm" c="dimmed"> {this.props.translate("content.extract.dashboard.UI.au moins" )} {environnementExpertiseMin[index]} {this.props.translate("content.extract.dashboard.UI.ans, au maximum" )} {environnementExpertiseMax[index]} {this.props.translate("content.extract.dashboard.UI.ans" )} </Text>
                        {this.props.translate("context." + domain )}
                        <Space h="xs" />
                        <RangeSlider
                          min={0}
                          max={15}
                          step={1}
                          minRange={1}
                          style={{ position: 'relative', zIndex: 0 }}
                          value={[environnementExpertiseMin[index], environnementExpertiseMax[index]]}
                          onChange={(newValues) => this.handleRangeChange_Environnement(newValues, index)}
                        />
                        <Space h="xl" />
                      </>
                    ))}
                    </Paper></Grid.Col></> : <></>}                   


                  <Space h="md" />
                </Grid>
                <Space h="md" />
                <Center>
                  <Button onClick={() => this.setState(prevState => ({ reload: prevState.reload + 1 }))}>
                    {this.props.translate("content.extract.dashboard.apply")}
                  </Button>
                </Center>
              </Collapse>
            </Grid.Col>

            <Grid.Col span={12}>
              {this.state.consultants.length > 0 ? 
              <>
                <GetDashboardStatistic translate={this.props.translate} datatochart={this.filterDataToChart(this.state.consultants)} formoption={this.props.list} exporttype={"Dashboard"} />
              </>
              : <> no consultants corresponding to filter :c</>}
            </Grid.Col>

          </Grid>

          <br></br>
        </div>
      )
    };
  }


function mapStateToProps(state) {
    return {
        data: state.dashboard.data,
        list: state.dashboard.list
    };
}


export default connect(mapStateToProps, { fetchDashboard,getAutocompleteList })(withLocalize(Dashboard));
